import fetchContactForm from './fetchContactForm';
import delay from './helpers/delay';

const sendContactForm = async (e) => {
  e.preventDefault();

  const feedbackForm = document.querySelector('[data-feedback-form]');
  const feedbackFormSubmissionErrorMessage = feedbackForm.querySelector('[data-submission-error-message]');
  const feedbackFormSubmissionSuccessMessage = feedbackForm.querySelector('[data-submission-success-message]');
  
  const { target } = e;
  const { action } = target;
  const formData = new FormData(target);

  const dataToSend = {
    lead_data: {
      user_type: null,
      interest: null,
      comments: null,
    },
  };

  for (const [key, value] of formData) {
    // console.warn(key, value);

    if (key === 'user_type' || key === 'interest' || key === 'comments') {
      dataToSend['lead_data'][key] = value;
      continue;
    } else {
      dataToSend[key] = value;
    }
  }

  feedbackForm.classList.add('is_loading');
  feedbackFormSubmissionErrorMessage.classList.remove('is_active');
  feedbackFormSubmissionSuccessMessage.classList.remove('is_active');

  await delay(1000);

  try {
    const response = await fetchContactForm(action, dataToSend);
    feedbackFormSubmissionSuccessMessage.classList.add('is_active');
    target.reset();
    gtag('event', 'связаться_с_нами___amocrm');
  } catch (error) {
    feedbackFormSubmissionErrorMessage.classList.add('is_active');
    throw new Error(`Fetch error occured: ${error}`);
  } finally {
    feedbackForm.classList.remove('is_loading');
  }
};

export default sendContactForm;
